<template>
  <div style="background-color: #fff" class="pt-2">
  <v-card-actions class="px-5 py-3">
      <v-spacer></v-spacer>
      <label class="btn my-0" for="uploads">選擇檔案</label>
      <input
        type="file"
        id="uploads"
        style="position: absolute; clip: rect(0 0 0 0)"
        accept="image/png, image/jpeg, image/jpg"
        @change="uploadImg($event, 1)"
      />
      <button @click="final" class="btn my-0" v-if="option.img">確認</button>
    </v-card-actions>
    <div
      class="cut my-0 mt-0 mb-7"
      :class="{ 'cut-huge': this.cropWidth > 1200 }"
    >
      <vue-cropper
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="true"
        :full="option.full"
        :fixed="fixed"
        :fixed-number="fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        @real-time="realTime"
        :high="option.high"
        mode="cover"
        :max-img-size="option.max"
        @crop-moving="cropMoving"
      ></vue-cropper>
    </div>
    <!--<div
      class="show-preview mt-0 ma-7"
      v-if="previews.h > 0"
      :style="{
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '5px',
      }"
    >
      <div :style="previews.div">
        <img :src="previews.url" :style="previews.img" />
      </div>
    </div>-->
    <v-divider></v-divider>
    <!--<v-card-actions class="px-5 py-3">
      <v-spacer></v-spacer>
      <label class="btn my-0" for="uploads">選擇檔案</label>
      <input
        type="file"
        id="uploads"
        style="position: absolute; clip: rect(0 0 0 0)"
        accept="image/png, image/jpeg, image/gif, image/jpg"
        @change="uploadImg($event, 1)"
      />
      <button @click="final" class="btn my-0" v-if="option.img">確認</button>
    </v-card-actions>-->

    <!--<div class="test-button">
      <button @click="changeImg" class="btn">changeImg</button>
      <label class="btn" for="uploads">upload</label>
      <input
        type="file"
        id="uploads"
        style="position: absolute; clip: rect(0 0 0 0)"
        accept="image/png, image/jpeg, image/gif, image/jpg"
        @change="uploadImg($event, 1)"
      />
      <button @click="startCrop" v-if="!crap" class="btn">start</button>
      <button @click="stopCrop" v-else class="btn">stop</button>
      <button @click="clearCrop" class="btn">clear</button>
      <button @click="refreshCrop" class="btn">refresh</button>
      <button @click="changeScale(1)" class="btn">+</button>
      <button @click="changeScale(-1)" class="btn">-</button>
      <button @click="rotateLeft" class="btn">rotateLeft</button>
      <button @click="rotateRight" class="btn">rotateRight</button>
      <button @click="finish('base64')" class="btn">preview(base64)</button>
      <button @click="finish('blob')" class="btn">preview(blob)</button>
      <a @click="down('base64')" class="btn">download(base64)</a>
      <a @click="down('blob')" class="btn">download(blob)</a>
      <a @click="() => (option.img = '')" class="btn">清除图片</a>
      <div style="display: block; width: 100%">
        <label class="c-item">
          <span>上传图片是否显示原始宽高 (针对大图 可以铺满)</span>
          <input type="checkbox" v-model="option.original" />
          <span>original: {{ option.original }}</span>
        </label>
        <label class="c-item">
          <span>能否拖动图片</span>
          <input type="checkbox" v-model="option.canMove" />
        </label>
        <label class="c-item">
          <span>能否拖动截图框</span>
          <input type="checkbox" v-model="option.canMoveBox" />
          <span>canMoveBox: {{ option.canMoveBox }}</span>
        </label>
        <label class="c-item">
          <span>截图框固定大小</span>
          <input type="checkbox" v-model="option.fixedBox" />
          <span>fixedBox: {{ option.fixedBox }}</span>
        </label>
        <label class="c-item">
          <span>是否输出原图比例的截图</span>
          <input type="checkbox" v-model="option.full" />
          <span>full: {{ option.full }}</span>
        </label>
        <label class="c-item">
          <span>是否自动生成截图框</span>
          <input type="checkbox" v-model="option.autoCrop" />
          <span>autoCrop: {{ option.autoCrop }}</span>
        </label>
        <label class="c-item">
          <span>是否根据dpr生成适合屏幕的高清图片</span>
          <input type="checkbox" v-model="option.high" />
          <span>high: {{ option.high }}</span>
        </label>
        <label class="c-item">
          <span>截图框是否限制在图片里(只有在自动生成截图框时才能生效)</span>
          <input type="checkbox" v-model="option.centerBox" />
          <span>centerBox: {{ option.centerBox }}</span>
        </label>
        <label class="c-item">
          <p>输出图片格式</p>
          <label
            >jpg
            <input
              type="radio"
              name="type"
              value="jpeg"
              v-model="option.outputType"
            />
          </label>
          <label
            >png
            <input
              type="radio"
              name="type"
              value="png"
              v-model="option.outputType"
            />
          </label>
          <label
            >webp
            <input
              type="radio"
              name="type"
              value="webp"
              v-model="option.outputType"
            />
          </label>
        </label>
      </div>
    </div>-->
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  data() {
    return {
      model: false,
      modelSrc: "",
      crap: false,
      previews: {},
      lists: [
        {
          img: "",
        },
      ],
      option: {
        img: "",
        size: 1,
        full: false,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 640,
        autoCropHeight: 150,
        centerBox: false,
        high: true,
        max: 99999,
      },
      show: true,
      fixed: true,
      fixedNumber: [16, 9],
      expanded: [],
      transitioned: [],
      closeTimeouts: {},
    };
  },
  props: ["cropRatio", "cropWidth"],
  components: {
    VueCropper,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  mounted() {
    this.fixedNumber = this.cropRatio;
    this.option.autoCropWidth = this.cropWidth;
  },

  methods: {
    changeImg() {
      this.option.img = this.lists[~~(Math.random() * this.lists.length)].img;
    },
    startCrop() {
      // start
      this.crap = true;
      this.$refs.cropper.startCrop();
    },
    stopCrop() {
      //  stop
      this.crap = false;
      this.$refs.cropper.stopCrop();
    },
    clearCrop() {
      // clear
      this.$refs.cropper.clearCrop();
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    finish(type) {
      // 输出
      // var test = window.open('about:blank')
      // test.document.body.innerHTML = '图片生成中..'
      if (type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          console.log(data);
          var img = window.URL.createObjectURL(data);
          this.model = true;
          this.modelSrc = img;
          console.log(this.modelSrc);
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true;
          this.modelSrc = data;
          console.log(this.modelSrc);
        });
      }
    },
    final() {
      let vm = this;
      this.$refs.cropper.getCropData((data) => {
        this.model = true;
        //this.modelSrc = data;
        console.log("原始", data);
        console.log(
          "測試",
          data.substring(data.indexOf("/") + 1, data.indexOf(";base64"))
        );
        this.compress(data, 1, function (base64) {
          console.log("壓縮完成", base64);
          vm.modelSrc = base64;
          vm.$emit("update", vm.modelSrc);
        });
      });
    },
    compress(base64, rate, callback) {
      let vm = this;
      let _img = new Image();
      _img.src = base64;
      _img.onload = function () {
        let _canvas = document.createElement("canvas");
        let w = this.width / rate;
        let h = this.height / rate;
        _canvas.setAttribute("width", w);
        _canvas.setAttribute("height", h);
        _canvas.getContext("2d").drawImage(this, 0, 0, w, h);
        let base64 = _canvas.toDataURL(`image/${vm.option.outputType}`);
        _canvas.toBlob(function (blob) {
          if (blob.size > 750 * 1334) {
            this.compress(base64, rate, callback);
          } else {
            callback(base64);
          }
        }, `image/${vm.option.outputType}`);
      };
    },
    realTime(data) {
      this.previews = data;
      console.log(data);
    },
    finish2() {
      this.$refs.cropper2.getCropData((data) => {
        this.model = true;
        this.modelSrc = data;
      });
    },
    finish3() {
      this.$refs.cropper3.getCropData((data) => {
        this.model = true;
        this.modelSrc = data;
      });
    },
    down(type) {
      // event.preventDefault()
      var aLink = document.createElement("a");
      aLink.download = "demo";
      // 输出
      if (type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          this.downImg = window.URL.createObjectURL(data);
          aLink.href = window.URL.createObjectURL(data);
          aLink.click();
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.downImg = data;
          aLink.href = data;
          aLink.click();
        });
      }
    },
    uploadImg(e, num) {
      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (this.getFileExtension(e.target.value) == "png") {
        this.option.outputType = "png";
      } else {
        this.option.outputType = "jpeg";
      }
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          this.option.img = data;
        } else if (num === 2) {
          this.example2.img = data;
        }
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
    },
    // imgLoad(msg) {
    //   console.log(msg);
    // },
    cropMoving(data) {
      console.log(data, "截图框当前坐标");
    },
  },
};
</script>
<style>
.cut {
  width: 800px;
  height: 600px;
}

.cut-huge {
  width: 1500px;
  height: 1120px;
}
</style>
